export const ordersKeys = {
  all: ["orders"],
  track: (token) => ["orders", "track", token],
  trackCustom: (token) => ["orders", "track-custom", token],
};
